module.exports = __webpack_public_path__ + "static/media/delisted.9eff132f.svg";